import { extend, override } from 'flarum/common/extend';
import SignUpModal from 'flarum/forum/components/SignUpModal';

extend(SignUpModal.prototype, 'fields', function(items) {
  if (!this.isProvided('email')) {
    items.remove('username');
    items.remove('email');
    items.remove('password');
    items.remove('submit');
  }
});

override(SignUpModal.prototype, 'footer', function() {
  return;
});

override(SignUpModal.prototype, 'content', function() {
  if (!this.isProvided('email')) {
    return [<div className="Modal-body">Welcome to the CloudGG Community Forum!<br></br>This is your place to connect with other GeForce NOW Powered by Pentanet Players and our Support Team to discuss the service, read FAQs, provide feedback, report bugs, and help out fellow gamers.<br></br><br></br>The CloudGG Community Forum is only available to users with an active CloudGG account.<br></br>Please go to cloud.gg and Sign Up today.<br></br><br></br><p className="SignUpModal-logIn">{app.translator.trans('core.forum.sign_up.log_in_text', { a: <a onclick={this.logIn.bind(this)} /> })}</p>{this.body()}</div>];
  } else {
    return [<div className="Modal-body">{this.body()}</div>];
  }
});

override(SignUpModal.prototype, 'body', function() {
  return [<div className="Form Form--centered">{this.fields().toArray()}</div>];
});
